module.exports = __webpack_public_path__ + "static/media/BroomeAdvertiser-devicecomp-min@2x.cfbcaf21.png";